import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { IconName, IconWrapper, IndexedIcon, SvgIcon } from '../../Icon';
import {
  HighlightedEntity,
  withHighlightingContext,
} from '../../HighlightingContext';
import {
  useActionsVisibilityContext,
  withActionsVisibilityContext,
} from '../../ActionsVisibilityContext';
import ThinDivider from '../../ThinDivider';
import { borderedContent } from '../../../styles/shareableStyles';

interface IProps {
  children: ReactNode;
  iconName: IconName;
  iconPositiveIndex?: number;
  gap?: number;
}

const Container = styled(HighlightedEntity)<{ $gap: number }>`
  display: flex;
  align-items: flex-start;
  column-gap: ${({ $gap }) => $gap}px;
  min-height: 48px;
  padding: 7px 16px;
  ${borderedContent};
`;

const StaticWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  column-gap: 16px;
  margin-top: 4px;
`;

const ContentWrapper = styled.div`
  flex: 1;
  align-self: center;
`;

const BuilderSectionCard = ({
  children,
  iconName,
  iconPositiveIndex,
  gap,
}: IProps) => {
  const { showActions, hideActions } = useActionsVisibilityContext();

  return (
    <Container
      onMouseEnter={showActions}
      onMouseLeave={hideActions}
      $gap={gap || 16}
    >
      <StaticWrapper>
        {iconPositiveIndex && iconPositiveIndex > 0 ? (
          <IndexedIcon
            name={iconName}
            positiveIndex={iconPositiveIndex}
            isActive={true}
          />
        ) : (
          <IconWrapper>
            <SvgIcon name={iconName} width={16} height={16} isActive={true} />
          </IconWrapper>
        )}
        <ThinDivider layout="vertical" size="short" />
      </StaticWrapper>
      <ContentWrapper>{children}</ContentWrapper>
    </Container>
  );
};

export default withHighlightingContext(
  withActionsVisibilityContext(BuilderSectionCard),
);
